import accountSettingsTemplateContent from './accountSettingsTab';

export default accountSettingsTemplateContent;
